import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Link from "./Link";
import OpenNewIcon from "../Svg/Icons/OpenNew";
var StyledLink = styled(Link).withConfig({
    componentId: "sc-1f57527e-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "\n  &:hover{\n    color: ".concat(theme.colors.text, ";\n    svg{\n      fill: ").concat(theme.colors.text, ";\n    }\n  }\n  ") : "\n  &:hover{\n    color: ".concat(theme.colors.success, ";\n    svg{\n      fill: ").concat(theme.colors.success, ";\n    }\n  }\n  ");
});
var LinkExternal = function(_param) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(StyledLink, _object_spread_props(_object_spread({
        external: true
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(OpenNewIcon, {
                color: props.color,
                ml: "5px",
                width: "14px"
            })
        ]
    }));
};
export default LinkExternal;
